import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, Slide, withStyles } from 'material-ui';
import DialogStyles from './EditPassengerDialogStyles';
import EditPassenger from '../common/editPassenger/EditPassenger';

function Transition (props) {
  return <Slide direction='down' {...props} />;
}

const EditPassengerDialog = ({ editOpened, handleClose, classes, selectedPassenger }) => (
  <div className='edit-passenger-dialog'>
    <Dialog
      fullScreen
      open={editOpened}
      onClose={handleClose}
      transition={Transition}
      classes={classes}
    >
      <EditPassenger handleClose={handleClose} selectedPassenger={selectedPassenger} />
    </Dialog>
  </div>
);

EditPassengerDialog.propTypes = {
  handleClose: PropTypes.func,
  editOpened: PropTypes.bool,
  classes: PropTypes.object,
  selectedPassenger: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]),
};

export default withStyles(DialogStyles)(EditPassengerDialog);



// WEBPACK FOOTER //
// ./src/containers/passengers/mobile/EditPassengerDialog.js